var map = {
	"./uploads/2016/12/10_Jeg_pusler_meg_framover.mp3": 1718,
	"./uploads/2016/12/11_Fruen_fra_havet.mp3": 6667,
	"./uploads/2016/12/12_Sitat_av_Konrad_Adenauer.mp3": 9838,
	"./uploads/2016/12/13_Turistens_klagan.mp3": 6958,
	"./uploads/2016/12/14_Vaare_smaa_sosken.mp3": 451,
	"./uploads/2016/12/15_Bolge.mp3": 5963,
	"./uploads/2016/12/16_Hyllediktet.mp3": 9970,
	"./uploads/2016/12/17_Paa_jorden_et_sted.mp3": 7524,
	"./uploads/2016/12/18_Folk_i_husan.mp3": 4025,
	"./uploads/2016/12/19_Vennskap.mp3": 7742,
	"./uploads/2016/12/1_Vi_besynger.mp3": 2776,
	"./uploads/2016/12/20_Sebradiktet.mp3": 5862,
	"./uploads/2016/12/21_Haru_vaert_ongdom.mp3": 3199,
	"./uploads/2016/12/22_Hva_kan_du_eie.mp3": 9418,
	"./uploads/2016/12/23_Mange_mennesker.mp3": 6282,
	"./uploads/2016/12/24_Er_borte.mp3": 2540,
	"./uploads/2016/12/25_Lev_livet_langsomt.mp3": 4483,
	"./uploads/2016/12/26_Kardemommeloven.mp3": 5182,
	"./uploads/2016/12/27_Til_hjertene.mp3": 9798,
	"./uploads/2016/12/28_Aforisme.mp3": 9360,
	"./uploads/2016/12/29_Vaar_beste_dag.mp3": 6414,
	"./uploads/2016/12/2_Hyss.mp3": 8953,
	"./uploads/2016/12/30_Sitat_av-Seneca_31_32.mp3": 1725,
	"./uploads/2016/12/33_Marcus_Tullios_Cicero.mp3": 4464,
	"./uploads/2016/12/34_Aforismer.mp3": 9485,
	"./uploads/2016/12/35_Jeg_hadde_tenkt.mp3": 194,
	"./uploads/2016/12/36_Sitat_av_King.mp3": 1778,
	"./uploads/2016/12/37_Romeo.mp3": 8450,
	"./uploads/2016/12/38_Spor_i_sand.mp3": 6256,
	"./uploads/2016/12/39_Jeg_har_lett.mp3": 1726,
	"./uploads/2016/12/3_Lovetannens_bonn.mp3": 3526,
	"./uploads/2016/12/40_Trassvisa.mp3": 4484,
	"./uploads/2016/12/41_Dette_flyktige_som_varer.mp3": 1674,
	"./uploads/2016/12/42_Ved_havet.mp3": 3466,
	"./uploads/2016/12/43_Maaken.mp3": 3056,
	"./uploads/2016/12/44_Skjer.mp3": 504,
	"./uploads/2016/12/45_En_strimma_hav.mp3": 9904,
	"./uploads/2016/12/46_Hav_sommer.mp3": 1441,
	"./uploads/2016/12/47_Hva_poesi_er.mp3": 5247,
	"./uploads/2016/12/48_Borders.mp3": 5655,
	"./uploads/2016/12/49_Sitat_av_Astrid_Lindgren.mp3": 5689,
	"./uploads/2016/12/4_Kjaerlighet.mp3": 7198,
	"./uploads/2016/12/50_Notteliten.mp3": 4435,
	"./uploads/2016/12/51_Barneregle.mp3": 9299,
	"./uploads/2016/12/52_Sitat_av_Soren_Kierkegaard.mp3": 4279,
	"./uploads/2016/12/53_Eg_tenkjer_paa_kommunen_min.mp3": 4059,
	"./uploads/2016/12/54_Vindusplass.mp3": 4233,
	"./uploads/2016/12/5_Det_er_langt_mellom_venner.mp3": 687,
	"./uploads/2016/12/6_Veien_gjennom_Bokeskogen.mp3": 7685,
	"./uploads/2016/12/7_Mauren.mp3": 5351,
	"./uploads/2016/12/8_Mote.mp3": 3421,
	"./uploads/2016/12/9_Paradiset.mp3": 2144,
	"./uploads/2018/05/55-Elisabeth-Frye-1.mp3": 5428,
	"./uploads/2018/05/56-Jag-vil-leva-i-Europa.mp3": 6128,
	"./uploads/2018/05/57-Hur-kan-jag-sega.mp3": 4188,
	"./uploads/2018/05/58-De-elskendes-jul.mp3": 3727,
	"./uploads/2018/05/59-Seg-til-om-jag-stør.mp3": 7409,
	"./uploads/2018/05/60-Ner-jag-hør.mp3": 3263,
	"./uploads/2018/05/61-Kjærlighetens-høysang.mp3": 6930,
	"./uploads/2018/05/62-En-enmandsseng.mp3": 1861,
	"./uploads/2018/05/63-Vi-kan-ikkje-eige.mp3": 5155,
	"./uploads/2018/05/64-Asfalt.mp3": 251,
	"./uploads/2018/05/65-Mysteriet-deg-2.mp3": 4511,
	"./uploads/2018/05/66-Boken.mp3": 8767,
	"./uploads/2018/05/67-Ung-Son.mp3": 3612,
	"./uploads/2018/05/68-Og-stjernene.mp3": 7777,
	"./uploads/2018/05/69-Norske-sjøfolk-tilegnet.mp3": 8808,
	"./uploads/2018/05/70-Bønn-for-en-liden-syklist.mp3": 9646,
	"./uploads/2018/05/71-Trær.mp3": 2716,
	"./uploads/2018/05/74-Så-tag-mit-hjerte.mp3": 8154,
	"./uploads/2018/05/75-Trygve-Skaug.mp3": 7295,
	"./uploads/2018/05/76-Profeten.mp3": 704,
	"./uploads/2018/05/77-Eg-prøver-ei-seng.mp3": 8785,
	"./uploads/2018/05/78-Den-dag-kjem-aldri.mp3": 6226,
	"./uploads/2018/05/79-Farr-på-kjøkkenet.mp3": 9669,
	"./uploads/2018/05/80-The-first-time.mp3": 1500,
	"./uploads/2018/06/72-Kalypso.mp3": 2189,
	"./uploads/2018/06/73-Lyn-ogTorden.mp3": 5227,
	"./uploads/2018/06/81-Mor.mp3": 5752,
	"./uploads/2018/06/82-Døden-kan-jeg-forestille-meg.mp3": 3053,
	"./uploads/2021/03/100-Kolbein-Falkeid.mp3": 681,
	"./uploads/2021/03/101-Carl-Frederik-Pryts.mp3": 6712,
	"./uploads/2021/03/103-Annerledes.mp3": 7939,
	"./uploads/2021/03/106-Jens-Gundersen.mp3": 7237,
	"./uploads/2021/03/83-Klart-det-er-du-som-Trygve-Skaug.mp3": 4437,
	"./uploads/2021/03/84-Wergeland.mp3": 333,
	"./uploads/2021/03/85-ANTONIO-MACHADO.mp3": 613,
	"./uploads/2021/03/86.-Karin-Boye-2.mp3": 4440,
	"./uploads/2021/03/87-Lagerkvist.mp3": 9491,
	"./uploads/2021/03/88-Rolf-Jacobsen-.mp3": 5754,
	"./uploads/2021/03/89-Olav-Bull.mp3": 9839,
	"./uploads/2021/03/90-Colin-Archer.mp3": 9372,
	"./uploads/2021/03/91-Herman-Vildenvey.mp3": 2964,
	"./uploads/2021/03/92-Kielland.mp3": 1175,
	"./uploads/2021/03/93-TRond-Botnen.mp3": 3766,
	"./uploads/2021/03/94-Marit-Hjorthol.mp3": 6721,
	"./uploads/2021/03/96-Olav-H.-Hauge.mp3": 7787,
	"./uploads/2021/03/97-Bodvar.mp3": 5306,
	"./uploads/2021/03/98-Kari-Bremnes.mp3": 4525,
	"./uploads/2021/03/99-Oystein-Hauge.mp3": 6596,
	"./uploads/2021/04/Kjorsvik.mp3": 9573,
	"./uploads/2021/09/110-Ferdaminne.mp3": 4163,
	"./uploads/2021/10/Bernt-Hugo-Blomquist-2.mp3": 7728,
	"./uploads/2023/04/105-Arnt-Birkedal.mp3": 8437,
	"./uploads/2023/04/95-Arnold-Eidslott-MARIN1-07.04.2024.mp3": 7253,
	"./uploads/2023/12/107-Jon-Ståle-Ritland.mp3": 3192,
	"./uploads/2023/12/108-Sara-Zahid.mp3": 1831,
	"./uploads/2023/12/109-Martin-Nieuller.mp3": 8064,
	"./uploads/2023/12/111-Bernt-Hugo-Blomquist.mp3": 9413,
	"./uploads/2023/12/112-Thor-Soorheim.mp3": 4212,
	"./uploads/2023/12/115-Puta-av-Gro-Dale.mp3": 8001,
	"./uploads/2023/12/116-Edvard-Hoem.mp3": 7652,
	"./uploads/2023/12/117-Lars-Saabye-Christensen.mp3": 9522
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5656;